import * as generalAPI from '../../../general/api';

export function getTests(params) {
  return generalAPI.getTests({ cloudType: 'vdc', ...params });
}

export function getTestCasesTrends(params) {
  return generalAPI.getTestCasesTrends({ cloudType: 'vdc', ...params });
}
